<!-- Zweck: Stellt die HTML-Struktur für shop einkaufs statistik web button component im Frontend bereit. -->
@if (artikel.EinkaufsStatistikWeb?.length > 0 && (viewcomp.visible_artikel_einkaufsstatistik|async)) {
  <div>
    @if (!(viewcomp.visible_artikel_einkaufsstatistik|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
      <button (click)="showEinkaufsStatistikWeb(artikel)"
        mat-icon-button
        matTooltip="Anzeigen">
        <svg-icon>plus</svg-icon>
      </button>
    }
    @if ((viewcomp.visible_artikel_einkaufsstatistik|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
      <button (click)="hideEinkaufsStatistikWeb(artikel)"
        mat-icon-button
        matTooltip="Ausblenden">
        <svg-icon>minus</svg-icon>
      </button>
    }
  </div>
}


